<template>
  <app-page form class="workspace">
    <h1 class="title mb-4">ご利用人数などを入力して下さい</h1>

    <card-book-car class="mb-4"/>

    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onSubmit"
      >
        <v-card-text class="pb-0">
          <h2 class="mt-4 mb-3">利用人数</h2>
          <p class="guide mb-4 caption">
            ご利用になる人数を入力下さい。<br>
            <small>(各車両の乗車定員をご確認下さい)</small>
          </p>
          <v-text-field
            label="利用人数"
            type="number"
            suffix="名"
            v-model="peoples"
            :min="1"
            :max="carseat"
            :rules="[rules.required('利用人数'), rules.peoples(carseat)]"
            outlined
            autofocus
          />

          <h2 class="mt-8 mb-3">クーポン</h2>
          <div class="guide mb-4 caption">
            <p>
              利用可能なクーポンがある場合、クーポンコードを入力頂くと特典を受けることができます。
            </p>
            <p>
              クーポンコードは大文字小文字に注意し、半角で入力ください。<br>
              右側の<kbd>入力</kbd>ボタンをクリックすることで確定します。
            </p>
          </div>
          <v-text-field
            label="クーポンコード"
            type="text"
            v-model="couponCode"
            outlined
            :error-messages="couponReason"
            @input="onChangeCoupon"
            @keydown.enter.prevent="onInputCoupon"
          >
            <template v-slot:append>
              <v-btn
                type="button"
                depressed
                color="primary"
                style="margin-top: -7px;"
                @click="onInputCoupon"
              >
                <span>入力</span>
              </v-btn>
            </template>
          </v-text-field>
          <v-messages
            v-if="couponSummary.length > 0"
            style="padding: 8px 10px; border: solid 1px; border-radius: 3px;"
            color="success"
            :value="couponSummary"
          />

          <h2 class="mt-8 mb-3">連絡事項</h2>
          <p class="guide mb-4 caption">
            店舗への連絡事項などございましたらお電話にてお願いいたします。<br />
            TEL 092-411-5984
          </p>
        </v-card-text>

        <v-card-actions class="px-4">
          <v-spacer/>
          <v-btn type="submit" color="primary">次へ</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </app-page>
</template>

<script>
import ShopBase from '@/app/special/mixins/ShopBase'
import CardBookCar from '../BookComponents/CardBookCar'
import * as rules from '@/libs/rules'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'BookRemark',
  mixins: [
    ShopBase('摘要')
  ],
  components: {
    CardBookCar
  },
  data: () => ({
    // 利用人数
    peoples: 1,

    // クーポンコード
    couponCode: '',
    couponSummary: [],
    couponReason: '',

    // 連絡事項
    note: '',

    rules,
    valid: true
  }),
  computed: {
    ...mapState('book', {
      s_peoples: state => state.peoples,
      s_couponCode: state => state.couponCode,
      s_note: state => state.note
    }),
    ...mapGetters('book', {
      b_car: 'bookCar',
      b_coupons: 'bookCoupons'
    }),
    carseat () {
      return this.b_car ? this.b_car.seat : 1
    }
  },
  created () {
    this.addFetcher(() => this.fetch())
  },
  methods: {
    ...mapMutations('book', [
      'setBookPeoples',
      'setBookNote'
    ]),
    ...mapActions('book', [
      'setBookCouponCode'
    ]),

    fetch () {
      this.peoples = this.s_peoples
      this.couponCode = this.s_couponCode
      this.note = this.s_note

      if (this.b_coupons.length > 0) {
        this.couponSummary = [
          `クーポン ${this.b_coupons[0].name} を適用します`,
          this.b_coupons[0].note
        ]
      }

      return true
    },

    onSubmit () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.setBookPeoples(this.peoples)
      this.setBookNote(this.note)

      // 次のページへ
      this.$router.push({ name: 'book-confirm' })
    },

    onChangeCoupon () {
      if (this.couponCode === '') {
        this.setBookCouponCode('')
        this.couponReason = ''
        this.couponSummary = []
      }
    },

    async onInputCoupon () {
      this.couponSummary = []
      this.couponReason = ''

      const result = await this.setBookCouponCode(this.couponCode)
      if (!result.ok) {
        this.couponReason = result.reason
        return
      }

      if (result.coupon) {
        this.couponSummary = [
          `クーポン ${result.coupon.name} を適用します`,
          result.coupon.note
        ]
      }
    }
  }
}
</script>
